import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearnerFlatMap.vue?vue&type=template&id=872770be"
import script from "./EnacAtplDashboardPhaseLearnerFlatMap.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearnerFlatMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports